import React, {useEffect, useRef, useState} from 'react';
import {connect} from "react-redux";
import { withRouter } from 'react-router-dom';
import {setOrderImage, updateOfficialOrderName} from "./actions/mainPageActions";

function ProjectRow({history, lastUsedAttachment, data, setOrderImage, updateOfficialOrderName}) {
    // Zmień na map zamiast single ref
    const fileInputRefs = useRef({});
    let initialData = [];
    const [initialArray, setInitialArray] = useState(initialData);
    const [projectData, setProjectData] = useState(initialArray);
    const [dragOverIndex, setDragOverIndex] = useState(-1);
    const [isEditing, setIsEditing] = useState([]);
    const [editValue, setEditValue] = useState("");
    const [editedIndex, setEditedIndex] = useState(-1);
    const [oldValue, setOldValue] = useState("");

    const handleSetEditValue = (value) => {
        setEditValue(value);
        let tmp = projectData;
        tmp[editedIndex].officialOrderName = value;
        setProjectData(tmp);
    }

    const handleEditClick = (index) => {
        setOldValue(projectData[index].officialOrderName)
        setEditedIndex(index);
        let arr = [];
        arr[index]=true
        setIsEditing(arr);
    };

    const handleSave = () => {
        setIsEditing([]);
        updateOfficialOrderName(data[editedIndex].id, projectData[editedIndex].officialOrderName )
    };

    const handleCancel = () => {
        let tmp = projectData;
        tmp[editedIndex].officialOrderName = oldValue;
        setProjectData(tmp);
        setIsEditing([]);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSave();
        } else if (e.key === 'Escape') {
            handleCancel();
        }
    };

    useEffect(() => {
        if(data) {// && data[0]
            setInitialArray(data);
            setProjectData(data);
        }
    }, [data])

    const styles = {
        container: {
            display: 'flex',
            backgroundColor: '#fff',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            padding: '16px',
            alignItems: 'center',
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            justifyContent: 'space-between',
            gap: '16px',
            marginBottom: '10px'
        },
        image: {
            width: '160px',
            height: '100px',
            borderRadius: '8px',
            objectFit: 'cover',
            cursor: 'pointer', // Added cursor to indicate it's droppable
            transition: 'opacity 0.2s ease', // Added transition for drag over effect,
            marginLeft: '50px',
            marginRight: '50px'
        },
        // Added style for drag over state
        imageDragOver: {
            width: '160px',
            height: '100px',
            borderRadius: '8px',
            objectFit: 'cover',
            cursor: 'pointer',
            opacity: '0.7',
            border: '2px dashed #2196f3',
            transition: 'opacity 0.2s ease'
        },
        contentLeft: {
            flex: '1',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            maxWidth: 'calc(33% - 250px)'
        },
        content: {
            flex: '1',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        header: {
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            fontSize: '15px',
            fontWeight: '600',
            color: 'rgb(52, 71, 103)',
            marginBottom: '6px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
        },
        calendarInfo: {
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            fontWeight: '500',
            fontSize: '12px',
            color: 'rgb(52, 71, 103)',
            marginBottom: '4px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
        },
        partInfo: {
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            fontWeight: '500',
            fontSize: '12px',
            color: 'rgb(52, 71, 103)',
            marginBottom: '2px'
        },
        problemDesc: {
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            fontWeight: '500',
            fontSize: '12px',
            color: 'rgb(52, 71, 103)',
        },
        rightSection: {
            textAlign: 'right',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            alignItems: 'flex-end',
            minHeight: '10px',
        },
        partsChecked: {
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            fontWeight: '500',
            fontSize: '12px',
            color: 'rgb(52, 71, 103)',
            marginBottom: '35px'
        },
        button: {
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            backgroundColor: '#2196f3',
            color: '#fff',
            border: 'none',
            borderRadius: '15px',
            padding: '6px 12px',
            fontSize: '12px',
            fontWeight: '500',
            cursor: 'pointer'
        },
        noRows: {
            width: '100%',
            height: 60,
            backgroundColor: 'white',
            border: '1px solid rgba(0, 0, 0, 0.06)',
            boxShadow: 'rgba(0, 0, 0, 0.08) 0px 2px 8px',
            borderRadius: 12,
            textAlign: 'center',
            padding: 20,
        }
    };

    const handleRedirect = (id) => {
        const currentPath = history.location.pathname;
        if (currentPath.includes('/simulation')) {
            const basePath = currentPath.substring(0, currentPath.lastIndexOf('/'));
            history.push(`${basePath}/order/${id}`);
        } else {
            history.push(`/customer/dashboard/order/${id}`);
        }
    };

    const handleContainerClick = (e, id) => {
        // Lista elementów, które nie powinny triggerować redirect
        const excludedElements = ['IMG', 'INPUT', 'BUTTON', 'SVG', 'path'];
        const target = e.target;

        // Sprawdź czy kliknięty element jest jednym z wyjątków
        if (excludedElements.includes(target.tagName)) {
            return;
        }

        // Sprawdź czy rodzic jest SVG lub button
        if (target.closest('svg') || target.closest('button')) {
            return;
        }

        // Jeśli kliknięto w input
        if (target.closest('input[type="text"]')) {
            return;
        }

        // W pozostałych przypadkach redirect
        handleRedirect(id);
    };

    // Modified onDragOver function to prevent default and provide visual feedback
    const onDragOver = (e, index) => {
        console.log("onDragOver for index:", index);
        e.preventDefault();
        setDragOverIndex(index); // Set which image is being dragged over
    };

    // Modified onDragLeave function to clear visual feedback
    const onDragLeave = (e, index) => {
        console.log("onDragLeave for index:", index);
        e.preventDefault();
        setDragOverIndex(-1); // Clear drag over state
    };

    // Modified onDrop function to update specific image
    const onDrop = (ev, index) => {
        console.log("onDrop for index:", index);
        ev.preventDefault();
        setDragOverIndex(-1); // Clear drag over state

        // Check if we have a lastUsedAttachment with a valid image URL
        if (lastUsedAttachment && lastUsedAttachment.url) {
            let newImageUrl = lastUsedAttachment.url;

            // Handle different file types - only update if it's an image
            if (lastUsedAttachment.fullName) {
                const fileName = lastUsedAttachment.fullName.toLowerCase();
                const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'];
                const isImage = imageExtensions.some(ext => fileName.includes(ext));

                if (!isImage) {
                    console.log("Dropped file is not an image:", fileName);
                    return; // Don't update if it's not an image
                }
            }

            // Update the specific project's image URL
            setProjectData(prevData => {
                const newData = [...prevData];
                newData[index] = {
                    ...newData[index],
                    image: newImageUrl
                };
                return newData;
            });
            setOrderImage(data[index].id, lastUsedAttachment.url)
        }
    };

    const handleImageClick = (index) => {
        // Użyj ref dla konkretnego indeksu
        fileInputRefs.current[index]?.click();
    }

    const handleFileChange = (e, index) => {
        console.log('File change for index:', index)
        console.log(e)
        const file = e.target.files[0];
        if (!file) return;

        // Sprawdź czy to jest obrazek
        const fileName = file.name.toLowerCase();
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'];
        const isImage = imageExtensions.some(ext => fileName.includes(ext));

        if (!isImage) {
            console.log("Selected file is not an image:", fileName);
            return;
        }

        // Konwertuj plik do URL
        const reader = new FileReader();
        reader.onload = (event) => {
            const newImageUrl = event.target.result;

            // Użyj tej samej logiki co drag & drop
            setProjectData(prevData => {
                const newData = [...prevData];
                newData[index] = {
                    ...newData[index],
                    image: newImageUrl
                };
                return newData;
            });

            // Jeśli musisz wysłać na serwer - używaj data[index].id
            setOrderImage(data[index].id, newImageUrl);
        };

        reader.readAsDataURL(file);

        // Wyczyść input aby móc wybrać ten sam plik ponownie
        e.target.value = '';
    }

    return (
        <>
            {projectData.map((data, index) => {
                return (
                    <div
                        key={index}
                        style={{...styles.container, cursor: 'pointer'}}
                        onClick={(e) => handleContainerClick(e, data.id)}
                        role="button"
                        tabIndex={0}
                    >
                        <div style={styles.contentLeft}>
                            <div style={styles.header}>
                                {!isEditing[index] ? (
                                    <>
                                        <svg
                                            width="14"
                                            height="14"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="#999"
                                            strokeWidth="2"
                                            xmlns="http://www.w3.org/2000/svg"
                                            onClick={() => handleEditClick(index)}
                                            style={{cursor: 'pointer', marginRight: '8px'}}
                                        >
                                            <path d="M12 20h9"/>
                                            <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/>
                                        </svg>
                                        <span onClick={(e) => {
                                            handleEditClick(index);
                                            e.stopPropagation()}
                                        } style={{cursor: 'pointer'}}>
                            {data.officialOrderName}
                        </span>
                                    </>
                                ) : (
                                    <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                        <input
                                            type="text"
                                            value={data.officialOrderName}
                                            onChange={(e) => handleSetEditValue(e.target.value)}
                                            onKeyDown={handleKeyPress}
                                            onClick={(e) => e.stopPropagation()}
                                            autoFocus
                                            style={{
                                                border: '1px solid #ccc',
                                                borderRadius: '4px',
                                                padding: '4px 8px',
                                                fontSize: 'inherit',
                                                fontFamily: 'inherit'
                                            }}
                                        />
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleSave();
                                            }}
                                            style={{
                                                background: '#4CAF50',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '4px',
                                                padding: '4px 8px',
                                                cursor: 'pointer',
                                                fontSize: '12px'
                                            }}
                                        >
                                            ✓
                                        </button>
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleCancel();
                                            }}
                                            style={{
                                                background: '#f44336',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '4px',
                                                padding: '4px 8px',
                                                cursor: 'pointer',
                                                fontSize: '12px'
                                            }}
                                        >
                                            ✕
                                        </button>
                                    </div>
                                )}
                            </div>
                            <div style={styles.partInfo}>Order nr: {data.orderNumber}</div>
                            <div style={styles.calendarInfo}>
                                <svg width="14" height="14" fill="none" stroke="#333" strokeWidth="2"
                                     viewBox="0 0 24 24">
                                    <path
                                        d="M8 7V3M16 7V3M3 11H21M5 5H19C20.1046 5 21 5.89543 21 7V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V7C3 5.89543 3.89543 5 5 5Z"
                                        strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Create date {data.createDate}
                            </div>
                        </div>
                        <input
                            type="file"
                            ref={(el) => {
                                if (el) fileInputRefs.current[index] = el;
                            }}
                            style={{ display: 'none' }}
                            onChange={(e) => handleFileChange(e, index)}
                            accept="image/*"
                            onClick={(e) => e.stopPropagation()}
                        />
                        <img
                            src={data.image}
                            alt="Part"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleImageClick(index);
                            }}
                            style={{
                                cursor: 'pointer',
                                ...styles.image,
                                ...(dragOverIndex === index ? styles.imageDragOver : {})
                            }}
                            onDragOver={(e) => onDragOver(e, index)}
                            onDragLeave={(e) => onDragLeave(e, index)}
                            onDrop={(e) => onDrop(e, index)}
                            draggable={false}
                        />
                        <div style={styles.content}>
                            <div style={styles.partInfo}>Part: {data.part}</div>
                            <div style={styles.problemDesc}>Problem desc.: {data.problemDesc}</div>
                        </div>

                        <div style={styles.rightSection}>
                            <div style={styles.partsChecked}>Parts checked: {data.partsChecked.toLocaleString()}</div>
                            <button
                                style={styles.button}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleRedirect(data.id);
                                }}
                            >
                                VIEW PROJECT
                            </button>
                        </div>
                    </div>
                );
            })}
            {data && !data[0] && (<div style={styles.noRows}>No orders to show. Change filters, please.</div>)}
        </>
    );
}

const mapStateToProps = ({ filesWidgetReducer, instructionsReducer, clientPanel }) => {
    return {
        lastUsedAttachment: filesWidgetReducer.lastUsedAttachment,
        versions: instructionsReducer.versions,
        data: clientPanel.mainPageReducer.rows,
    }
}

function mapDispatchToProps () {
    return dispatch => ({
        setOrderImage: (orderId, image) => dispatch(setOrderImage(orderId, image)),
        updateOfficialOrderName: (orderId, value) => dispatch(updateOfficialOrderName(orderId, value))
    });
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProjectRow));